export class ClientPatientResponseModel {
  Text: string;
  ClientId: number;
  RegId?: number;
}
